import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Loader } from '@piggytechng/component-library';
import { useDebounce } from '../../../../../helpers/utils';
import NoData from '../../../../../components/NoData/NoData';
import useIpo from '../../../../../hooks/useIpo';
import IpoIdentifierCards from './IpoIdentifierCards';
import IpoOfferList from './IpoOfferList';
import './IpoTab.scss';

const OFFER_PREVIEW_COUNT = 3;

const IpoTab = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 400);

  const { investor, investments, investmentsHasNextPage, isLoadingInvestments } = useIpo({
    fetchInvestments: true,
    fetchInvestor: true,
    investmentLimit: OFFER_PREVIEW_COUNT,
  });

  const query = debouncedSearch.toLowerCase();
  const previewOffers = query
    ? investments.filter(
        (item) => item.offerName.toLowerCase().includes(query) || item.offerId.toLowerCase().includes(query),
      )
    : investments;

  return (
    <div className="ipo-tab">
      <IpoIdentifierCards chn={investor?.chn || undefined} cscs={investor?.cscs || undefined} />

      <div className="ipo-tab__toolbar">
        <input
          className="ipo-tab__search"
          placeholder="Search by offer name or ID"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="ipo-tab__header flex--3">
        <h2>IPO Investments</h2>
        {(investmentsHasNextPage || investments.length === OFFER_PREVIEW_COUNT) && (
          <span className="ipo-tab__view-all pointer" onClick={() => navigate(`/view-all-ipo/${id}/all`)}>
            View all
          </span>
        )}
      </div>

      {isLoadingInvestments ? (
        <div className="ipo-tab__loader">
          <Loader color="#0F60D6" />
        </div>
      ) : previewOffers.length > 0 ? (
        <IpoOfferList
          items={previewOffers}
          onItemClick={(item) => navigate(`/view-ipo-offer/${id}/${item.offerId}`, { state: { offer: item } })}
        />
      ) : (
        <NoData message={search ? 'No IPO investments match your search.' : 'No IPO investments at the moment.'} />
      )}
    </div>
  );
};

export default IpoTab;
